import capitalizeFirstLetter from './capitalizeFirstLetter';

function capitalizeWords(string: string) {
  return string.split(' ').map(capitalizeFirstLetter).join(' ');
}

export default capitalizeWords;
